import { useState, useEffect, forwardRef } from 'react'

interface OptimizedImageProps {
  className?: string,
  src: string,
  alt?: string,
  quality?: string,
  widths?: Array<number>,
  sizes?: string,
  fetchPriority?: 'auto' | 'high' | 'low' | undefined,
  ref?: React.RefObject<HTMLImageElement | null>
  aspectRatio?: number,
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement>) => void,
}

const defaultWidths = [300, 500, 800, 1200, 1600]
// Default sizes used for the images in the Library component
const defaultSizes = '(min-width: 83em) calc(20vw - 1.625em), (min-width: 66.5em) calc(25vw - 1.625em), calc(33vw - 1.625em)'

const OptimizedImage = forwardRef<HTMLImageElement, OptimizedImageProps>(({
  className,
  src,
  alt = '',
  quality = 'auto',
  widths = defaultWidths,
  sizes = defaultSizes,
  fetchPriority = 'auto',
  aspectRatio = 1,
  onLoad
}, ref) => {
  const [imageSrcSet, setImageSrcSet] = useState<string>('')

  function getSrcsetString (srcString: string, width: number, quality: string) {
    const replacementString = `f_auto,w_${width},q_${quality}`
  
    if (srcString.includes('upload')) {
      return srcString.replace('/upload/', `/upload/${replacementString}/`)
    } 
  
    return srcString
  }

  useEffect(() => {
    if(src) {
      const newSrcSet = widths
        .map(width => `${getSrcsetString(src, width, quality)} ${width}w`)
        .join(', ')
    
      setImageSrcSet(newSrcSet)
    }
  }, [src])
  
  return (
    <div>
      <img
        className={className}
        style={{ aspectRatio: aspectRatio }}
        src={src}
        alt={alt}
        srcSet={imageSrcSet}
        sizes={sizes}
        fetchPriority={fetchPriority}
        ref={ref}
        onLoad={onLoad}
      />
    </div>
  )
})

OptimizedImage.displayName = 'OptimizedImage'

export default OptimizedImage